import {
  deleteElement,
  fetchElements,
  saveElementsType,
  updateElement,
} from "@/lib/utils";
import type { AdditionalLayer } from "@/types/models/capas";
import type { CapasRepository } from "@/lib/repositories/interfaces/capas-repository.interface";

const CAPAS_ADICIONALES_FIELDS = [
  "*",
  "translations.*",
  "entidades_capa.*",
  "entidades_capa.propiedades_capa.*",
] as const;

export const capasRepository: CapasRepository = {
  fetchByTenant: (tenantId: number): Promise<AdditionalLayer[]> =>
    fetchElements<AdditionalLayer>(
      "capas_adicionales",
      [...CAPAS_ADICIONALES_FIELDS],
      undefined,
      {
        tenant: { _eq: tenantId },
      },
      {
        entidades_capa: {
          _limit: -1,
        },
      }
    ),

  create: async (payload: Partial<AdditionalLayer>): Promise<AdditionalLayer> =>
  (await saveElementsType<AdditionalLayer>("capas_adicionales", [payload]))[0],

  update: (id: number, changes: Partial<AdditionalLayer>) =>
    updateElement("capas_adicionales", id, changes),

  delete: (id: number): Promise<void> =>
    deleteElement("capas_adicionales", id),
};
